import React from "react";

function Home({ productId, setProductId, fetchIngredients, loading, ingredients = [], error }) {
  return (
    <div className="container">
      <div className="banner">
        <h1 className="header">Lebensmittel-Inhaltsstoff-Suche</h1>
      </div>
      <p className="subHeader">
        Geben Sie eine Produkt-ID ein, um die zugehörigen Zutaten zu finden.
      </p>
      <div className="inputContainer">
        <input
          type="number"
          placeholder="Produkt-ID eingeben"
          value={productId}
          onChange={(e) => setProductId(e.target.value)}
          className="input"
        />
        <button onClick={fetchIngredients} className="button">
          {loading ? "Suche läuft..." : "Suchen"}
        </button>
      </div>

      {error && <p className="error">{error}</p>}

      {Array.isArray(ingredients) && ingredients.length > 0 ? (
        <div className="result">
          <h3>Zugehörige Zutaten:</h3>
          <ul>
            {ingredients.map((item, index) => (
              <li key={index} className="ingredient">
                {item.ingredient}
              </li>
            ))}
          </ul>
        </div>
      ) : (
        <p className="subHeader">Noch keine Zutaten gefunden.</p>
      )}
    </div>
  );
}

export default Home;
